import { useEffect, useState, PropsWithChildren, useCallback } from "react";
import { IntlProvider } from "react-intl";
import messages from "../intl";

export const escapeWithExtraSingleQuote = (str: string) =>
  str.replace(/'{2,}|('(?!'))/g, ($0, $1) => ($1 ? "''" : $0));

export const getDynamicMessageId = (message: string, idPrefix = "") =>
  Object.values(messages)
    .filter(m => m.id.startsWith(idPrefix))
    .find((desc) => desc.defaultMessage === escapeWithExtraSingleQuote(message),
  )?.id ?? `unknown.message.${Date.now()}`;

export const getArgumentDictionary = (template: string, args: string[]) => {
  const reg = /\{\s*([\w\d]+)\s*\}/g;

  const rv: Record<string, string> = {};

  let match = reg.exec(template);
  let i = 0;

  while (match) {
    const key = match[1];
    rv[key] = args[i++];
    match = reg.exec(template);
  }

  return rv;
};

export function I18n({
  locale,
  children,
}: PropsWithChildren<{ locale: string }>) {
  const [currentMessages, setCurrentMessages] = useState<Record<string, string>>();

  const load = useCallback(async () => {
    const localizedMessages = await import(`../locales/${locale}.json`).catch(
      () => import(`../locales/en.json`),
    );

    setCurrentMessages(localizedMessages);
  }, [locale]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <IntlProvider defaultLocale="en" locale={locale} messages={currentMessages}>
      {children}
    </IntlProvider>
  );
}
